const getCruiseTransportChanges = (passengers, originalPassengers) => {
  const changes = [];
  if (!originalPassengers || !passengers || passengers.length !== originalPassengers.length) {
    return changes;
  }

  for (let index = 0; index < passengers.length; index += 1) {
    const origTransport = (originalPassengers[index].travelerPreferences || {})
      .cruiseTransportPreference || {};
    const cruiseTransport = (passengers[index].travelerPreferences || {})
      .cruiseTransportPreference || {};
    if (origTransport.mode !== cruiseTransport.mode
      || origTransport.cityCode !== cruiseTransport.cityCode) {
      changes.push({
        passenger: passengers[index],
        isChanged: true,
      });
    }
  }
  return changes;
};

export default getCruiseTransportChanges;
